/**
 * Worker classification types for shifts.
 *
 * W-2: Traditional employees with taxes withheld, entitled to benefits and labor protections.
 * 1099: Independent contractors who are self-employed and handle their own taxes.
 */
export const workerClassifications = [
  { id: '1099', label: '1099' },
  { id: 'w2', label: 'W2' },
] as const

export type WorkerClassification = (typeof workerClassifications)[number]['id']

export const workerClassificationIds = workerClassifications.map(
  (c) => c.id
) as unknown as readonly [WorkerClassification, ...WorkerClassification[]]
